import { render } from "./vplusinvite.vue?vue&type=template&id=47428af7&scoped=true"
import script from "./vplusinvite.vue?vue&type=script&lang=js"
export * from "./vplusinvite.vue?vue&type=script&lang=js"

import "./vplusinvite.vue?vue&type=style&index=0&id=47428af7&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境租户后台rent.syinba.com/jsvueweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47428af7"]])

export default __exports__